// extracted by css-extract-rspack-plugin
export default {"Box":"slicer-panel-resizer-module__Box__xgQl6","Box_1":"slicer-panel-resizer-module__Box_1__IcVHa","isDragging":"slicer-panel-resizer-module__isDragging__GPk44"};